export function userAgent() {
	return navigator.userAgent;
}